export const CLOUD_FUNCTIONS = {
  CREATE_ADMIN: 'userCreateAdmin',
  CREATE_DEMO_USER: 'userCreateDemoUser',
  SIGN_IN_AS_USER: 'userSignInAsUser',
  SIGN_OUT_FROM_USER: 'userSignOutFromUser',
  UPDATE_ALL_STATISTICS: 'statisticsCollectAll',
};
